import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyImageModule } from '@/helpers/lazyImageModule';
import { MobileNavComponent } from './mobileNav.component';

@NgModule({
    imports: [ RouterModule, CommonModule, LazyImageModule ],
    declarations: [ MobileNavComponent ],
    exports: [ MobileNavComponent ],
})

export class MobileNavModule {}
